import { Tabs, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

// Seasonal 메뉴 하나로 통합 (결정 ① · docs/V1_ADMIN_SCREEN_REVIEW.md §5-4 1단계)
// 두 화면은 그대로 두고 위에 같은 탭 줄을 둔다 — URL·동작 변화 없음
const TABS = [
  { path: '/seasonal', label: '캠페인 발송' },
  { path: '/seasonal-products', label: '제품·캠페인 설정' },
];

function SeasonalTabs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const value = TABS.some((t) => t.path === pathname) ? pathname : false;
  return (
    <Tabs
      value={value}
      onChange={(_, v) => navigate(v)}
      sx={{ mb: 2, borderBottom: 1, borderColor: 'divider', '& .MuiTab-root': { textTransform: 'none', fontWeight: 600 } }}
    >
      {TABS.map((t) => (
        <Tab key={t.path} value={t.path} label={t.label} />
      ))}
    </Tabs>
  );
}

export default SeasonalTabs;
